require('../../scss/frontend/history.scss');